module.exports = __webpack_public_path__ + "img/schema_otn_1a BIS.d67cecb9.svg";